<template>
  <div id="list">
    <h2 class="uppercase text-left text-xl">Casiers</h2>
    <div id="grid-0-1" class="grid grid-cols-2 gap-4">
      <div id="elements-list" class="py-2">
        <ToggleButton
          v-for="box of project"
          :key="box"
          :class="[box.position === activeBox ? 'filled' : '', 'smallest']"
          :text="`${box.position + 1}`"
          @click="$emit('selectedBox', box.position)"
          :hideIcon="true"
        />
      </div>
      <GenericButton class="my-2" :text="'AJOUTER'" :icon="'plus'" @click="$emit('newBox')" />
    </div>
  </div>
</template>

<script>
import GenericButton from '@/components/ui/GenericButton.vue';
import ToggleButton from '../ui/ToggleButton.vue';

export default {
  name: 'List',
  components: {
    GenericButton,
    ToggleButton,
  },
  props: {
    project: Object,
    activeBox: Number,
  },
};
</script>

<style scoped>
#elements-list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow-x: auto;
  gap: 1rem;
}

#grid-0-1 {
  grid-template-columns: 1fr auto;
}
</style>
